import iconCommon from '@/assets/icons/badges/common.png';
import iconUncommon from '@/assets/icons/badges/uncommon.png';
import iconRare from '@/assets/icons/badges/rare.png';
import iconEpic from '@/assets/icons/badges/epic.png';
import iconLegendary from '@/assets/icons/badges/legendary.png';
import iconMythic from '@/assets/icons/badges/mythic.png';

export type IconBadge = 'common' | 'uncommon' | 'rare' | 'epic' | 'legendary' | 'mythic';

export function getIconBadge(rarity: IconBadge) {
    switch (rarity) {
        case 'uncommon':
            return iconUncommon;
        case 'rare':
            return iconRare;
        case 'epic':
            return iconEpic;
        case 'legendary':
            return iconLegendary;
        case 'mythic':
            return iconMythic;
        default:
            return iconCommon;
    }
}